import { OrganizationKeyName } from "../../../model/Organization";
import { Product } from "../../products/models/product";

export const GET_PRODUCT_SUCCESS = "SHOP:GET_PRODUCT_SUCCESS";

export const getProductSuccessAction = (
  organization: OrganizationKeyName,
  id: string,
  data: Product
) => ({
  type: GET_PRODUCT_SUCCESS as typeof GET_PRODUCT_SUCCESS,
  organization,
  id,
  data,
});

export type GetProductSuccessAction = ReturnType<
  typeof getProductSuccessAction
>;
